<template lang="pug" functional>
  .consultants-table-row-skeleton
    v-card.consultants-table-row-skeleton__item(
      v-for="i in props.count"
      :key="i")
      .consultants-table-row-skeleton__loader
      .consultants-table-row-skeleton__loader
      .consultants-table-row-skeleton__loader
      .consultants-table-row-skeleton__loader
      .consultants-table-row-skeleton__loader

</template>

<script>
export default {
  name: 'ConsultantsTableRowSkeleton',

  props: {
    count: {
      type: Number,
      default: 7
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .consultants-table-row-skeleton {
    margin-top: 1rem;
    
    &__item {
      height: 4.5rem;
      margin-bottom: 1rem;
      padding: 1rem 2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__loader {
      height: 2.5rem;
      border-radius: .8rem;
      width: 15%;

      &:last-child {
        margin-right: 5rem;
      }

      @include skeleton;
    }
  }
</style>
